export default function About() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            了解韩漫之家的故事与使命
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/60">
          <div className="flex flex-col items-center text-center gap-5">
            <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-home-smile-2-line text-3xl text-primary-600"></i>
            </div>

            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
              <p>
                韩漫之家成立于2024年，是国内领先的韩漫下载安装与离线阅读服务平台。
                我们致力于为广大韩漫爱好者提供最便捷、最安全的韩漫APK获取渠道，
                以及最全面的韩漫资源导航。
              </p>
              <p>
                平台目前已收录<strong className="text-foreground-900">3000+部韩漫作品</strong>，
                涵盖恋爱、奇幻、动作、悬疑、BL等全品类，
                所有推荐均经过人工筛选与安全检测，确保用户获得优质的韩漫离线阅读体验。
              </p>
              <p>
                <strong className="text-foreground-900">离线韩漫，随时随地，想读就读</strong> —
                这是韩漫之家一直坚持的服务理念。无论是通勤路上、旅行途中，还是网络不佳的环境，
                韩漫之家都让你的韩漫阅读不受限。
              </p>
            </div>

            <div className="flex flex-wrap justify-center gap-8 mt-2">
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-600 font-heading">2年+</div>
                <div className="text-xs text-foreground-400">稳定运营</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-600 font-heading">50万+</div>
                <div className="text-xs text-foreground-400">月活用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-600 font-heading">3000+</div>
                <div className="text-xs text-foreground-400">韩漫资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-600 font-heading">99.8%</div>
                <div className="text-xs text-foreground-400">安全通过率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}